import React, { Component } from 'react';
import { FuseSplashScreen } from '@fuse';
import { connect } from 'react-redux';
import * as userActions from 'app/auth/store/actions';
import { bindActionCreators } from 'redux';
import * as Actions from 'app/store/actions';
import { getTheme } from 'app/main/settings/store/actions/general.actions';
import jwtService from './store/actions/jwtService';
import decode from 'jwt-decode';

class Auth extends Component {
	state = { waitAuthCheck: true };

	componentDidMount() {
		return Promise.all([this.jwtCheck()]).then(() => {
			this.setState({ waitAuthCheck: false });
		});
	}

	jwtCheck = () =>
		new Promise(resolve => {
			jwtService.on('onAutoLogin', () => {
				jwtService
					.signInWithToken()
					.then(token => decode(token))
					.then(({ user }) => {
						this.props.setUserData(user);
						// Load theme after successful login
						this.props.getTheme();
						resolve();
					})
					.catch(() => {
						this.props.showMessage({ message: 'Session ended.' });
						resolve();
					});
			});
			jwtService.on('onAutoLogout', message => {
				if (message) {
					this.props.showMessage({ message });
				}
				this.props.logout();
				resolve();
			});
			jwtService.on('createUserError', message => {
				this.props.showMessage({ message });
				resolve();
			});
			jwtService.on('onNoAccessToken', () => resolve());
			jwtService.init();
			return Promise.resolve();
		});

	render() {
		return this.state.waitAuthCheck ? <FuseSplashScreen /> : <React.Fragment children={this.props.children} />;
	}
}

const mapDispatchToProps = dispatch => {
	return bindActionCreators(
		{
			logout: userActions.logoutUser,
			setUserData: userActions.setUserData,
			showMessage: Actions.showMessage,
			hideMessage: Actions.hideMessage,
			getTheme: getTheme
		},
		dispatch
	);
};

export default connect(null, mapDispatchToProps)(Auth);
